import type { IntervalFieldSource } from '@jira/polaris__domain-field/src/IntervalFieldSources.tsx';
import type { FieldKey } from '@jira/polaris__domain-field/src/FieldKey.types.tsx';
import {
	fireTrackAnalytics,
	type UIAnalyticsEvent,
} from '@atlassian/jira-product-analytics-bridge';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import { createGetFieldByKey } from './createGetFieldByKey.tsx';
import type { Props, State } from './FieldsUpdate.types.tsx';

export const updateIntervalFieldSource =
	(
		fieldKey: FieldKey,
		source: IntervalFieldSource | undefined,
		contextAnalyticsEvent: UIAnalyticsEvent,
	) =>
	async (
		{ getState, setState }: StoreActionApi<State>,
		{ fieldRemote }: Props,
		// oxlint-disable-next-line typescript/no-invalid-void-type
	): Promise<Error | void> => {
		const state = getState();
		// oxlint-disable-next-line typescript/no-non-null-assertion
		const currentField = createGetFieldByKey(fieldKey)(state)!;

		const oldConfiguration = currentField.configuration ? currentField.configuration : {};
		const newConfiguration = { ...currentField.configuration };

		if (source) {
			newConfiguration.source = source;
		} else {
			delete newConfiguration.source;
			delete newConfiguration.aggregationType;
			delete newConfiguration.customfieldKey;
		}

		const fields = { ...getState().fields };
		fields[fieldKey] = {
			...fields[fieldKey],
			configuration: newConfiguration,
		};
		setState({ fields });

		await fieldRemote.updateFieldConfiguration({
			fieldKey,
			oldConfiguration,
			configuration: newConfiguration,
			type: 'updateIntervalFieldSource',
		});

		fireTrackAnalytics(contextAnalyticsEvent, 'issueFields updated', {
			issueFieldKey: fieldKey,
			issueFieldType: currentField.type,
			updatedItems: source
				? [{ name: 'source' }]
				: [{ name: 'source' }, { name: 'aggregationType' }, { name: 'customfieldKey' }],
		});
	};
